import { Task, Timestamp } from '@griply/types';
import { isBefore, isSameDay } from 'date-fns';

export type GetOverdueDateOptions = {
  task: Task;
  dueDate?: Timestamp | null;
  today: Timestamp;
};

export const getOverdueDate = ({
  task,
  dueDate,
  today,
}: GetOverdueDateOptions): Timestamp | undefined => {
  if (task.completedAt || !dueDate) {
    return undefined;
  }
  if (!isBefore(dueDate, today) || isSameDay(dueDate, today)) {
    return undefined;
  }
  return dueDate;
};
